import React, { useState, useEffect, useContext } from "react";
import {
  Container,
  Typography,
  Box,
  Divider,
  Alert,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
} from "@mui/material";
import { ContextSession } from "../../../services/ContextSession";
import CryptoJS from "crypto-js";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

const VerSolConstanciaSG = () => {
  const [loading, setLoading] = useState(false);
  const [solicitudData, setSolicitudData] = useState(null);
  const [error, setError] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const [consimageUrl, setConsImageUrl] = useState(null);
  let sessi = useContext(ContextSession);
  const SolicitudID = sessi.getVariable("IDsolConstanciaSG");

  const tiposConstancia = {
    1: "HISTORIAL DE COTIZACIONES",
    2: "RAZONADA",
    3: "SALDOS PROYECTADOS",
    4: "NO TENER PRÉSTAMO ACTIVO",
    5: "TRÁMITE EMBAJADA",
  };

  const obtenerNombreOficina = (idOficina) => {
    const oficinas = {
      1: "Tegucigalpa",
      2: "San Pedro Sula",
      3: "La Ceiba",
      4: "Choluteca",
      5: "Santa Rosa de Copán",
      6: "Santa Bárbara",
      7: "Juticalpa",
    };

    return oficinas[idOficina] || idOficina;
  };

  //const dominio = "http://127.0.0.1:8000";
  const dominio = "https://be.injupemp.gob.hn:8443";

  // Añade esta función fuera del componente
  function cleanBase64(base64Str) {
    if (!base64Str) return "";
    if (base64Str.startsWith('"') && base64Str.endsWith('"')) {
      base64Str = base64Str.slice(1, -1);
    }
    return base64Str.replace(/(\r\n|\n|\r)/gm, "").replace(/\s+/g, "");
  }

  useEffect(() => {
    const fetchData = async () => {
      if (!SolicitudID) return;
      setLoading(true);
      setError(null);

      try {
        const secretKey =
          "django-insecure-8mo+j636(t*_cj&s&&3$7@*vwsk#yyl0u5fbv-v*^-)e!y&k#8";
        const queryString = `IdConstancia=${SolicitudID}`;
        const signature = CryptoJS.HmacSHA256(
          queryString,
          secretKey,
        ).toString();

        const response = await fetch(
          `${dominio}/api/ConstanciaPag/Constancia/?IdConstancia=${SolicitudID}`,
          {
            // const response = await fetch(`http://172.20.7.10:8082/api/ConstanciaPag/Constancia/?IdConstancia=${SolicitudID}`, {
            headers: {
              "X-Signature": signature,
            },
          },
        );

        if (!response.ok)
          throw new Error("Error al obtener los datos de la solicitud");

        const data = await response.json();
        setSolicitudData(data);

        // Procesar imagen Base64 si existe
        // Procesar PDF Base64 si existe
        if (data.CopiaDNI) {
          const base64Pdf = cleanBase64(data.CopiaDNI);
          if (base64Pdf.length > 20) {
            setImageUrl(`data:application/pdf;base64,${base64Pdf}`);
          }
        }

        if (data.CopiaConstancia) {
          const base64Pdf2 = cleanBase64(data.CopiaConstancia);
          if (base64Pdf2.length > 20) {
            setConsImageUrl(`data:application/pdf;base64,${base64Pdf2}`);
          }
        }
      } catch (err) {
        console.error("Error al cargar datos:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [SolicitudID]);

  const formatDate = (dateString) => {
    if (!dateString) return "No especificada";
    const date = new Date(dateString);
    return date.toLocaleDateString() + " " + date.toLocaleTimeString();
  };

  const getEstadoText = (estadoId) => {
    const estados = {
      1: "Pendiente",
      2: "Pagada",
      3: "Emitida",
      4: "Rechazada",
    };
    return estados[estadoId] || `Desconocido (ID: ${estadoId})`;
  };

  const solicitud = solicitudData?.solicitud || solicitudData || null;
  const datosUsuario = solicitudData?.DatosUsuario || {};
  const lugarResidencia =
    solicitud?.LugarResidencia ||
    solicitud?.lugarResidencia ||
    solicitudData?.LugarResidencia ||
    solicitudData?.lugarResidencia ||
    "";
  const oficinaEntregaId =
    solicitud?.FKIdOficina ??
    solicitud?.fk_id_oficina ??
    solicitud?.idOficina ??
    solicitudData?.FKIdOficina ??
    solicitudData?.fk_id_oficina ??
    solicitudData?.idOficina ??
    null;

  const filas = solicitud
    ? [
        {
          label: "Tipo Constancia",
          value:
            tiposConstancia[solicitud?.fk_id_constancia] || "No especificado",
        },
        {
          label: "Número de Recibo",
          value: solicitud?.numero_recibo || "No especificado",
        },
        //{ label: 'Estado', value: getEstadoText(solicitud?.fk_id_estado) },
        { label: "Monto", value: `L. ${solicitud?.monto}` },
        {
          label: "Detalle",
          value: solicitud?.detalle_solicitud,
        },
        {
          label: "Teléfono Proporcionado",
          value: solicitud?.telefono,
        },
        {
          label: "Fecha de Registro",
          value: formatDate(solicitud?.fecha_registro),
        },
        {
          label: "Fecha de Pago",
          value: formatDate(solicitud?.fecha_pagada),
        },
        {
          label: "Fecha de Emisión",
          value: formatDate(solicitud?.fecha_emitida),
        },
        ...(lugarResidencia
          ? [
              {
                label: "Lugar de Residencia",
                value: lugarResidencia,
              },
            ]
          : []),
        ...(oficinaEntregaId
          ? [
              {
                label: "Oficina de Entrega",
                value: obtenerNombreOficina(oficinaEntregaId),
              },
            ]
          : []),
      ]
    : [];

  const filas2 = solicitud
    ? [
        { label: "DNI", value: datosUsuario.DNI },
        { label: "Nombre", value: datosUsuario.NombreCompleto },
        { label: "Correo", value: datosUsuario.Correo || "No especificado" },
        { label: "Teléfono", value: datosUsuario.Telefono },
        {
          label: "Estado Solicitante",
          value: datosUsuario.estado,
        },
      ]
    : [];

  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <Container maxWidth="lg" style={{ marginTop: 20 }}>
        <Typography
          variant="h4"
          align="center"
          gutterBottom
          fontWeight={"bold"}
        >
          Detalle de Solicitud de Constancia #{SolicitudID}
        </Typography>
        <Divider sx={{ mb: 2 }} />

        {error && (
          <Alert severity="error" sx={{ mb: 3 }}>
            {error}
          </Alert>
        )}

        {solicitudData && (
          <>
            <Box sx={{ mb: 4 }}>
              <Typography variant="h5" gutterBottom fontWeight={"bold"}>
                Información de la Solicitud
              </Typography>
              <TableContainer component={Paper}>
                <Table>
                  <TableBody>
                    {filas.map((fila, idx) => (
                      <TableRow
                        key={fila.label}
                        sx={{
                          backgroundColor: idx % 2 === 0 ? "#f5f5f5" : "#fff", // Gris suave y blanco
                        }}
                      >
                        <TableCell
                          component="th"
                          scope="row"
                          sx={{ fontWeight: "bold", fontSize: "1.18rem" }}
                        >
                          {fila.label}
                        </TableCell>
                        <TableCell sx={{ fontSize: "1.18rem" }}>
                          {fila.value}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>

            <Divider sx={{ mb: 2 }} />
            <Box sx={{ mb: 4 }}>
              <Typography variant="h5" gutterBottom fontWeight={"bold"}>
                Información del Solicitante
              </Typography>
              <TableContainer component={Paper}>
                <Table>
                  <TableBody>
                    {filas2.map((fila, idx) => (
                      <TableRow
                        key={fila.label}
                        sx={{
                          backgroundColor: idx % 2 === 0 ? "#f5f5f5" : "#fff", // Gris suave y blanco
                        }}
                      >
                        <TableCell
                          component="th"
                          scope="row"
                          sx={{ fontWeight: "bold", fontSize: "1.18rem" }}
                        >
                          {fila.label}
                        </TableCell>
                        <TableCell sx={{ fontSize: "1.18rem" }}>
                          {fila.value}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>

            <Box sx={{ mb: 4 }}>
              <Divider sx={{ mb: 2 }} />

              <Typography variant="h5" gutterBottom fontWeight={"bold"}>
                Copia de DNI
              </Typography>
              {imageUrl ? (
                <Box
                  sx={{
                    border: "1px solid #ccc",
                    borderRadius: 2,
                    overflow: "hidden",
                    width: "100%",
                    maxWidth: "1200px", // <-- Cambia aquí el ancho
                    mx: "auto",
                    minHeight: "650px", // <-- Más alto el iframe
                    boxShadow: 2,
                  }}
                >
                  <iframe
                    src={imageUrl}
                    title="Copia de DNI PDF"
                    width="100%"
                    height="650px" // <-- Más alto el visor PDF
                    style={{ border: "none", display: "block" }}
                  ></iframe>
                  <Box sx={{ textAlign: "center", mt: 2 }}>
                    <a
                      href={imageUrl}
                      download="Copia_DNI.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Descargar Copia de DNI (PDF)
                    </a>
                  </Box>
                </Box>
              ) : (
                <Alert severity="info">
                  No se encontró copia de DNI adjunta
                </Alert>
              )}
            </Box>

            {solicitudData.CopiaConstancia && (
              <Box>
                <Divider sx={{ mb: 2 }} />
                <Typography variant="h5" gutterBottom fontWeight={"bold"}>
                  Copia de Constancia de la institución donde laboró
                </Typography>
                {consimageUrl ? (
                  <Box
                    sx={{
                      border: "1px solid #ccc",
                      borderRadius: 2,
                      overflow: "hidden",
                      width: "100%",
                      maxWidth: "1200px", // <-- Cambia aquí el ancho
                      mx: "auto",
                      minHeight: "650px", // <-- Más alto el iframe
                      boxShadow: 2,
                    }}
                  >
                    <iframe
                      src={consimageUrl}
                      title="Copia de DNI PDF"
                      width="100%"
                      height="650px" // <-- Más alto el visor PDF
                      style={{ border: "none", display: "block" }}
                    ></iframe>
                    <Box sx={{ textAlign: "center", mt: 2 }}>
                      <a
                        href={consimageUrl}
                        download="Copia_DNI.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Descargar Copia de Constancia (PDF)
                      </a>
                    </Box>
                  </Box>
                ) : (
                  <Alert severity="info">
                    No se encontró copia de constancia adjunta
                  </Alert>
                )}
              </Box>
            )}
          </>
        )}
      </Container>
    </>
  );
};

export default VerSolConstanciaSG;
